import React from "react";
import styled from "styled-components";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ArrowForward } from "../../shared/icons";
import { Button } from "../Buttons";

const EmailFormContainer = styled.div<{ showIcon: boolean }>`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.showIcon ? "10px" : "0px")};
  background-color: ${(props) => (props.showIcon ? "#f6f6f6" : "transparent")};
  width: 100%;
`;

const StyledField = styled(Field)`
  flex: 1;
  border: none;
  outline: none;
  padding: 6px;
  font-size: 16px;
  background-color: transparent;
  font-family: "Sora", sans-serif;

  &::placeholder {
    color: #16161a;
  }
`;

const ActionButton = styled.button`
  background-color: #f6f6f6;
  border: none;
  outline: none;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: transparent;
  }

  svg {
    fill: white;
    width: 16px;
    height: 16px;
  }
`;

const ErrorText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #d91f27;
  margin-top: 5px;
  margin-left: 2px;
`;

const EmailSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

interface EmailFormProps {
  showIcon: boolean;
  onSubmit: (email: string) => void;
}

const EmailForm: React.FC<EmailFormProps> = ({ showIcon, onSubmit }) => {
  return (
    <Formik
      initialValues={{ email: "" }}
      validationSchema={EmailSchema}
      onSubmit={(values, { resetForm }) => {
        onSubmit(values.email);
        resetForm();
      }}
    >
      {({ errors, touched }) => (
        <Form>
          <EmailFormContainer showIcon={showIcon}>
            <StyledField type="email" name="email" placeholder="Your e-mail" />
            {showIcon ? (
              <ActionButton type="submit">
                <ArrowForward />
              </ActionButton>
            ) : (
              <Button type="submit" variant="primary">
                Sign up
              </Button>
            )}
          </EmailFormContainer>
          {errors.email && touched.email && (
            <ErrorText>{errors.email}</ErrorText>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default EmailForm;
